<template>
    <div class="">
        <div class="row align-items-end mb-1 mb-md-0">
            <div class="col-md-4">
                <label class="form-label">Organizasyonel Şube</label>
                <v-select-list :options="branches" label="Name" v-on:input="getTitles(false)" v-model="branch" placeholder="Şube"></v-select-list>
            </div>
            <div class="col-md-4">
                <label class="form-label">Unvan</label>
                <v-select-list :disabled="filterData.BranchId == null" :options="titles" label="Name" v-model="title" placeholder="Unvan"></v-select-list>
            </div>
            <div class="col-md-2">
                <label class="form-label">Çalışma Durumu</label>
                <select class="form-control" v-model="filterData.JobExit">
                    <option :value="null">Tümü</option>
                    <option :value="false">Çalışıyor</option>
                    <option :value="true">Ayrıldı</option>
                </select>
            </div>
            <!-- <div class="col-md-2">
                <label class="form-label">Netsis'te Var Mı?</label>
                <select class="form-control" v-model="filterData.IsIntegratedNetsis">
                    <option :value="null">Tümü</option>
                    <option :value="false">Netsis'te Yok</option>
                    <option :value="true">Netsis'te Var</option>
                </select>
            </div>
            <div class="col-md-2">
                <label class="form-label">Netsis Eksik Veri Var Mı?</label>
                <select class="form-control" v-model="filterData.IsEksikVeriNetsis">
                    <option :value="null">Tümü</option>
                    <option :value="true">Eksik Bilgisi Var</option>
                    <option :value="false">Eksik Bilgisi Yok</option>
                </select>
                
            </div> -->
            <div class="col-auto mt-2">
                <button class="btn btn-secondary" v-on:click="$emit('filter',filterData)">Filtrele</button>
            </div>
            <div class="col-auto mt-2">
                <button class="btn btn-dark" v-on:click="clearForm">Temizle</button>
            </div>
        </div>
    </div>
</template>

<script>
import CompanyApi from '@/api/company'
import HumanResourcesParameterApi from '@/api/human-resources-parameters'

export default {
    data(){
        return{
            branches:[],
            titles:[],
            filterData:{
                BranchId:null,
                EmployeeDepartmentTitleId:null,
                JobExit:false,
                IsIntegratedNetsis:null,
                IsEksikVeriNetsis:null
            }
        }
    },
    mounted(){
        this.getBranches()
    },
    methods:{
        clearForm(){
            this.filterData.EmployeeDepartmentTitleId = null
            this.filterData.BranchId = null
            this.filterData.JobExit = false
            this.filterData.IsIntegratedNetsis=null
            this.filterData.IsEksikVeriNetsis=null
            this.$emit('filter',this.filterData)
        },
        setFilterData(data){
            this.filterData = data
            this.getTitles(true)
        },
        getBranches(){
            CompanyApi.Branch.ListByCode('O').then(res=>{
                this.branches = res.data.Data
                this.branches?.unshift({
                    Id:null,
                    Name:"TÜMÜ"
                })
            })
        },
        getTitles(bool){
            if(this.filterData.BranchId){
                HumanResourcesParameterApi.EmployeeDepartmentTitle.List(this.filterData.BranchId).then(res=>{
                    this.titles = []
                    if(bool != true){
                        this.filterData.EmployeeDepartmentTitleId = null
                    }
                    this.titles = res.data.Data
                    this.titles?.unshift({
                        Id:null,
                        Name:"TÜMÜ"
                    })
                })
            }
        }
    },
    computed:{
        title:{
            get:function(){
                return this.titles.find(b=>b.Id==this.filterData.EmployeeDepartmentTitleId)
            },
            set:function(value){
                this.filterData.EmployeeDepartmentTitleId = value?.Id || null
            }
        },
        branch:{
            get:function(){
                return this.branches.find(b=>b.Id==this.filterData.BranchId)
            },
            set:function(value){
                this.filterData.BranchId = value?.Id || null
                this.filterData.EmployeeDepartmentTitleId = null
            }
        },
    }
}
</script>